import {useEffect, useState} from "react";
import DynamicBooleanField from "./DynamicBooleanField";
import DynamicTextField from "./DynamicTextField";
import DynamicSelectField from "./DynamicSelectField";
import DynamicDateField from "./DynamicDateField";
import DynamicTextAreaField from "./DynamicTextAreaField";
import DynamicMultiSelectField from "./DynamicMultiSelectField";
import DynamicRadioField from "./DynamicRadioField";

export default function DynamicField({field, setFieldValue, answer, error, instanceId, questionAnswers}) {

    const [value, setValue] = useState(answer ?? field.default ?? '');

    useEffect(() => {
        if (answer !== undefined && answer !== null) {
            setValue(answer);
        } else if (field.default !== undefined) {
            setValue(field.default);

            // also push default into parent state
            setFieldValue({
                code: field.code,
                value: field.default
            });
        }
    }, [answer]);



    const onFieldChange = (e) => {
        let newValue = e.target.value;

        if (field.type === "digits") {
            newValue = newValue.replace(/\D/g, '');
        }

        setValue(newValue);

        setFieldValue({
            value: newValue,
            code: field.code
        });
    };

    function findFieldValue(fieldCode) {
        for (const group of Object.values(questionAnswers)) {
            if (Array.isArray(group)) {
                for (const item of group) {
                    if (item?.[fieldCode] !== undefined) {
                        return item[fieldCode];
                    }
                }
            }

            if (typeof group === "object" && group !== null) {
                if (group[fieldCode] !== undefined) {
                    return group[fieldCode];
                }
            }
        }
        return undefined;
    }

    const resolveFlexibleField = () => {
        if (!field.flexible || !questionAnswers) return field;

        for (const rule of field.flexible) {
            const answerValue = findFieldValue(rule.question);

            if (rule.value !== undefined && answerValue === rule.value) {
                return {
                    ...field,
                    ...rule.field
                };
            }

            if (rule.values && rule.values.includes(answerValue)) {
                return {
                    ...field,
                    ...rule.field
                };
            }
        }

        return field;
    };

    const effectiveField = resolveFlexibleField();


    return <>

        {(effectiveField.type === "text" || effectiveField.type === "digits") && (
            <DynamicTextField field={effectiveField} value={value} onFieldChange={onFieldChange} error={error} />
        )}

        {(effectiveField.type === "textarea") && (
            <DynamicTextAreaField field={effectiveField} value={value} onFieldChange={onFieldChange} error={error} />
        )}

        {effectiveField.type === "date" && (
            <DynamicDateField field={effectiveField} value={value} onFieldChange={onFieldChange} error={error}  />
        )}

        {effectiveField.type === "select" && (
            <DynamicSelectField field={effectiveField} value={value} onFieldChange={onFieldChange} error={error}  />
        )}

        {effectiveField.type === "multiselect" && (
            <DynamicMultiSelectField field={effectiveField} value={value} onFieldChange={onFieldChange} error={error}  />
        )}

        {effectiveField.type === "boolean" &&
            <DynamicBooleanField field={effectiveField} value={value} onFieldChange={onFieldChange} error={error} instanceId={instanceId}  />
        }

        {effectiveField.type === "radio" &&
            <DynamicRadioField field={effectiveField} value={value} onFieldChange={onFieldChange} error={error} instanceId={instanceId}  />
        }

    </>
}